import React, { FC, useEffect, useState } from "react";
import { connect } from "react-redux";
import moment from "moment";
import './invoice.css';

import * as GeneralStore from "../../store/GeneralStore";
import { State } from "../../store";
import { customerApi } from "../../api/customerApi";
import { 
    DefaultButton, 
    SearchBox,
    Spinner,
 } from "@fluentui/react";
import { MdSwapVert, MdFilterList } from "react-icons/md";
import Select, { OptionTypeBase, components } from "react-select";
import InvoiceListItem from "./InvoiceListItem";
import DetailsPage from "./DetailsPage";

const sortingOptions = ['Recent', 'Oldest'];

type Props = GeneralStore.GeneralState &
  typeof GeneralStore.actionCreators;

const InvoicePage: FC<Props> = (props: Props) => {
  const [throughputData, setThroughputData] = useState<any>();
  const [selectedItem, setSelectedItem] = useState<any>(null);
  const [selectedTab, setSelectedTab] = useState(0);
  const [sort, setSort] = useState<OptionTypeBase>({ label: sortingOptions[0], value: sortingOptions[0] });
  const [invoiceList, setInvoiceList] = useState<any>([]);
  const [sortedInvoiceList, setSortedInvoiceList] = useState<any>([]);
  const [billingList, setBillingList] = useState<any>([]);
  const [sortedBillingList, setSortedBillingList] = useState<any>([]);
  const [isLoading, setIsLoading] = useState(false);
  const documents = ["./documents/service_agreement.pdf","./documents/terms_and_conditions.pdf"];

  const fetchInvoice = async() => {
    setIsLoading(true);
    let res = await customerApi.getIvoiceList();
    if(res){
      let alphabetical = res?.result.sort((a:any,b:any)=>{
        return (a?.product)?.localeCompare(b?.product);
      });
      setInvoiceList(alphabetical);
      setSortedInvoiceList(alphabetical);
    }
    setIsLoading(false);
  }

  const fetchBillings = async() => {
    setIsLoading(true);
    let res = await customerApi.getBillingList();
    if(res){
      let alphabetical = res?.result.sort((a:any,b:any)=>{
        return (a?.product)?.localeCompare(b?.product);
      });
      setBillingList(alphabetical);
      setSortedBillingList(alphabetical);
    }
    setIsLoading(false);
  }

  const onSelect = (val:any) => {
    setSelectedItem(val);
  }
  const onBack = () => {
    setSelectedItem(null);
  }

  const onSearch=(e:any)=>{
    if(e?.target!==undefined){
      if(e.target.value!==""){
        setSortedInvoiceList(invoiceList.filter((i:any)=>(i?.product)?.toUpperCase().includes((e.target.value).toUpperCase())))
        setSortedBillingList(billingList.filter((i:any)=>(i?.billTitle)?.toUpperCase().includes((e.target.value).toUpperCase())))
      }else{
        setSortedInvoiceList(invoiceList);
        setSortedBillingList(billingList);
      }
    }else{
      setSortedInvoiceList(invoiceList);
      setSortedBillingList(billingList);
    }
  }

  const Control = ({ children, ...props }:any) => {
        return (
        <components.Control {...props}>
            <MdSwapVert className={"select-icon"}/>Sort By: <span className="select-value">{sort.value}</span>{children[1]}
        </components.Control>
        );
    };

  useEffect(() => {
    // accountApi.validateToken();
    fetchInvoice();
    fetchBillings();
  }, []);

  useEffect(() => {
    let sort = invoiceList.sort((a:any,b:any)=>{
      return (b?.issuedDate) - (a?.issuedDate);
    });
    if(sort.label==="Recent"){
      setSortedInvoiceList(sort);
    }else{
      setSortedInvoiceList(sort.reverse());
    }
  }, [sort]);

  return (
    <>
      {selectedItem===null ? (
      <div className="wrapper">
        <div className="flex justify-between">
          <h1>{selectedTab===0?'Invoice':selectedTab===1?'Billing':'Documents'}</h1>
          <div className="tabs">
              <DefaultButton className={selectedTab===0?"active-tab":"tab"} onClick={()=>setSelectedTab(0)}>Invoice</DefaultButton>
              <DefaultButton className={selectedTab===1?"active-tab":"tab"} onClick={()=>setSelectedTab(1)}>Billing</DefaultButton>
              {/* <DefaultButton className={selectedTab===2?"active-tab":"tab"} onClick={()=>setSelectedTab(2)}>Documents</DefaultButton> */}
          </div>
        </div>
        <div className="table-wrapper" >
          <div className="table-header">
            <SearchBox placeholder="Search" className="searchbar" onChange={onSearch}/>
            <div className="d-flex justify-content-between align-items-center gap text-base">
                <Select
                    className="text-base interval-select"
                    value={sort}
                    options={sortingOptions.map(
                        item => ({ label: item, value: item })
                    )}
                    components={{ Control:Control }}
                    onChange={(e) => setSort(e)}
                />
                <DefaultButton className={'filter-btn'} onClick={()=>setSortedInvoiceList(sortedInvoiceList.reverse())}><MdFilterList/></DefaultButton>
            </div>
          </div>
          {isLoading&&(
            <Spinner/>
          )}
          {selectedTab===0 && (
            sortedInvoiceList?.map((i:any)=>
              <InvoiceListItem data={i} type={selectedTab} onSelect={onSelect}/>
            )
          )}
          {selectedTab===1 && (
            sortedBillingList.map((b:any)=>
              <InvoiceListItem data={b} type={selectedTab} onSelect={onSelect}/>
            )
          )}
          {selectedTab===2 && (
            documents.map((c:any)=>
              <InvoiceListItem data={c} type={selectedTab} onSelect={onSelect}/>
            )
          )}
        </div>
      </div>
      ):(
        <DetailsPage data={selectedItem} onBack={onBack} onSelect={onSelect}/>
      )}
      {/* <div
        style={{
          position: "fixed",
          bottom: "50px",
          right: "50px"
        }}
      >
        {props.versionNumber}
      </div> */}
    </>
  );
};

export default connect(
  (state: State) => ({
    ...state.general
  }),
  {
    ...GeneralStore.actionCreators
  }
)(InvoicePage as any);